<template>
  <div class="container_Gui_admin">
    <custom-editor-readonly :readonly="true" v-if="regulationFile.length>0" v-model="regulationFile"
                            :min-height="(screenHeight * 0.50 - 20) + 'px'"/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import CustomEditorReadonly from "@/components/CustomEditorReadonly.vue";
import {MessageBox, Message} from "element-ui";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "GuiChengList",
  components: {CustomEditorReadonly},
  props: ["competitionInfo"],
  data() {
    return {
      regulationFile: ""
    };
  },
  computed: {
    ...mapState([
      "screenHeight",
      "screenWidth",
      "eventInfo",
      "userInfo"
    ])
  },
  watch: {
    "competitionInfo": {
      immediate: true,
      handler() {
        if (this.competitionInfo) {
          this.regulationFile = this.competitionInfo.regulationFile
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.competitionInfo) {
      this.regulationFile = this.competitionInfo.regulationFile
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.container_Gui_admin {
  width: 100%;
  height: 50vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
</style>
